{
    "AppMenu_AppsTitle": "Menu",
    "AppMenu_Apps_Reporting": "Análises",
    "AppMenu_Apps_FastProvisioning": "Aprovisionamento rápido",
    "AppMenu_Apps_Administration": "Administração",
    "AppMenu_Apps_StatusAndTools": "Estado e ferramentas",
    "AppMenu_FavouritesTitle": "Favoritos",
    "NAME": "AppMenu",
    "AppMenu_NewUI": "Suíte CX",
    "AppMenu_ClassicUI": "Visual clássico",
    "AppMenu_NewUIBadge": "Novo",
    "AppMenu_NewUIInvite_AriaLabel": "Experimente o CX Suite",
    "AppMenu_NewUIInvite_Heading": "Confira o CX Suite",
    "AppMenu_NewUIInvite_Body": "Uma página inicial mais rápida, relatórios mais espaçosos e navegação mais clara. Experimente — você pode voltar à versão anterior quando quiser.",
    "AppMenu_NewUIInvite_Confirm": "Confira",
    "AppMenu_NewUIInvite_Dismiss": "Agora não"
}